module.exports = __webpack_public_path__ + "static/img/signup_pic1.48d638f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/signup_pic1.png
// module id = mFpn
// module chunks = 1